import { secretSet } from "@/utils/integrationSecrets";

// FT-196 CTR-02: ответ API «детектор недоступности провайдера Green-API открыт».
// API отдаёт его на любое действие мессенджеров как 503 с машинным кодом; поле
// `error` в этом ответе — прежнее значение (для старых мобильных бандлов), экран
// новых версий смотрит только на `code`.
export const PROVIDER_UNAVAILABLE_CODE = "provider_unavailable";

export function isGreenApiProviderUnavailable(error) {
  const response = error && error.response;
  return !!(response && response.status === 503 && response.data && response.data.code === PROVIDER_UNAVAILABLE_CODE);
}

// Чат WhatsApp доступен: у компании есть инстанс и задан его токен (значение токена браузер не получает).
export function whatsappChatReady(company) {
  return !!(company && company.chat_api_instance && secretSet(company, "chat_api_token"));
}

// FT-195 CTR-04: прокси чата WhatsApp (/api/v1/whatsapp_chat/*). Файл больше 20 МБ сервер отклоняет
// (422 `file_too_big`) — фронт проверяет до отправки.
export const WHATSAPP_CHAT_MAX_FILE_BYTES = 20 * 1024 * 1024;

// Ключ локали для ожидаемых ответов прокси (сбой провайдера, большой файл) или null — тогда ошибка общая.
export function whatsappChatErrorKey(error) {
  if (isGreenApiProviderUnavailable(error)) return "companies.green_api_provider_down";
  const response = error && error.response;
  if (response && response.status === 422 && response.data && response.data.error === "file_too_big") {
    return "crm.messages.file_too_big";
  }
  return null;
}
